import { Role } from 'model/Role';

export const routes = [
  'ledger',
  'report',
  'schedule',
  'arrangement',
  'member',
  'role',
  'partner',
  'contractor',
  'work-resource',
  'industrial-waste',
  'machinery',
  'att',
  'car',
  'work-process',
];
export const pages = ['list', 'show', 'create', 'edit', 'index'];

export type Route = (typeof routes)[number];
export type Page = (typeof pages)[number];

export const routeSiteMap: { [route in Route]: Page[] } = {
  ledger: ['list', 'show', 'create', 'edit'],
  report: ['list', 'show', 'create', 'edit'],
  schedule: ['list', 'show', 'create', 'edit'],
  arrangement: ['index'],
  member: ['list', 'show', 'create', 'edit'],
  role: ['list', 'create', 'edit'],
  partner: ['list', 'show', 'create', 'edit'],
  contractor: ['list', 'create'],
  ['work-resource']: ['list', 'create'],
  ['industrial-waste']: ['list', 'create'],
  machinery: ['list', 'create'],
  att: ['list', 'create'],
  car: ['list', 'create'],
  ['work-process']: ['list', 'create'],
  ['line-relation']: ['list', 'edit', 'set', 'code'],
};

export const routeLabelList: { [route in Route | 'pther']: string } = {
  ledger: '工事台帳',
  report: '日報管理',
  schedule: '工事着工表',
  arrangement: '人員手配',
  member: 'メンバー情報',
  role: '役職管理',
  partner: '協力業者情報',
  contractor: '元請管理',
  ['work-resource']: '工具管理',
  ['industrial-waste']: '産廃管理',
  machinery: '重機管理',
  att: 'ATT管理',
  car: '車両管理',
  ['work-process']: '作業内容',
  ['line-relation']: 'LINE連携',
  login: 'ログイン',
  other: 'その他の設定',
};

export const getRoleRoutePermissions = (role?: Role): { [route in Route]: Page[] } => ({
  ...(role?.permissions.ledgerEdit ? { ledger: ['list', 'show', 'create', 'edit'] } : {}),
  ...(role?.permissions.ledgerShow ? { ledger: ['list', 'show'] } : {}),
  ...(role?.permissions.reportEdit ? { report: ['list', 'show', 'create', 'edit'], schedule: ['list'] } : {}),
  ...(role?.permissions.reportCreate ? { report: ['list', 'show', 'create', 'edit'], schedule: ['list'] } : {}),
  ...(
    role?.permissions.userEdit
      ? {
        member: ['list', 'show', 'create', 'edit'],
        partner: ['list', 'show', 'create', 'edit'],
        ['line-relation']: ['list', 'edit', 'set', 'code'],
      }
      : {}
  ),
  ...(
    (role?.permissions.root || role?.permissions.userEdit)
      ? { role: ['list', 'create', 'edit'] }
      : {}
  ),
  ...(
    role?.permissions.masterDataManage
      ? {
        contractor: ['list', 'create'],
        ['work-resource']: ['list', 'create'],
        ['industrial-waste']: ['list', 'create'],
        machinery: ['list', 'create'],
        att: ['list', 'create'],
        car: ['list', 'create'],
        ['work-process']: ['list', 'create'],
      }
      : {}
  ),
  ...(
    role?.permissions.workSupervise
      ? {
        member: ['list', 'show'],
        partner: ['list', 'show'],
        contractor: ['list'],
        ['work-resource']: ['list'],
        ['industrial-waste']: ['list'],
        machinery: ['list'],
        att: ['list'],
        car: ['list'],
        ['work-process']: ['list'],
      }
      : {}
  ),
});

export const hasPermission = (route: Route, page: Page, role?: Role) => {
  const roleRoutePermissions = getRoleRoutePermissions(role);

  return (roleRoutePermissions[route] || []).includes(page);
};
